let { html, nothing, ref, createRef, CustomTokenHTMLElement } = lithtml;
let tag     = 'pages-page';
let version = '0.9.0';

let uniqueIndex = 0;

/**
 * Pages element that displays any Pages page inside an iframe
 */
class PagesPageElement extends CustomTokenHTMLElement {
    static get tag()     { return tag }
    static get version() { return version }

    // We want to rerender each time the page or tenant attribute changes
    static get observedAttributes() { return ['page', 'tenant']; }

    /**
     * Constructor
     */
    constructor() {
        super(PagesPageElement);

        let self = this;

        self._ad      = `wcid_${(new Date().getTime())}_${++uniqueIndex}`;
        self._ae    = createRef();
        self._af = self._af.bind(self);
    }

    /**
     * The rendered component
     */
    render() {
        let self    = this;
        let tenant  = self.tenant;
        let page    = self.page;
        let baseUrl = self.baseUrl;

        if (!(tenant && page)) {
            return nothing;
        }

        if (tenant.indexOf('{') !== -1 || page.indexOf('{') !== -1) {
            return nothing;
        }

        if (!baseUrl) {
            let environment = self.getAttribute('environment');

            // Should only come here if we're not depending on tokens
            if (tenant === 'public' && environment) {
                baseUrl = self.baseUrl = self._ag(environment === 'prod' ? 'idsrv.onpowel.com' : environment === 'qa' ? 'qaidsrv' : 'ciidsrv')
            }
            else {
                return nothing;
            }
        }

        let urlParams = (self.getAttribute('urlparams') || '').trimStart('?');

        urlParams = `${urlParams}${(urlParams ? '&' : '')}$wcid=${self._ad}`;

        return html`<style>:host{display:block;contain:content;overflow:hidden}iframe{margin:0;padding:0;width:100%;height:100%;overflow:hidden}</style>${baseUrl
                ? html`<iframe ${ref(self._ae)} sandbox="allow-downloads allow-scripts allow-same-origin allow-forms allow-popups allow-modals allow-popups-to-escape-sandbox" frameBorder="0" src="${baseUrl + '/' + tenant + (self._ah && (tenant !== 'public') ? '/home'  : '') + '?' + urlParams + '#/' + page }"></iframe>`
                : html`<div style="color:red">Could not find Pages url (no baseurl/environment attribute set and the location is unknown)!</div>`}`;
    }

    /**
     * Make sure we attach listener for postMessage's coming from the iframe
     */
    onConnected() {
        window.removeEventListener('message', this._af);
        window.addEventListener   ('message', this._af);
    }

    /**
     * Clean up when the component is disconnected from the DOM
     */
    onDisconnected() {
        window.removeEventListener('message', this._af);
    }

    /**
     * Listen on messages from the iframe
     */
    _af(event) {
        let self = this;
        let data = event.data;

        // Only interested in messages from the iframe in this component
        if (data.wcid !== self._ad) {
            return;
        }

        if (data.event === '$pages.needuserinfoandtoken') {
            self.$triggerEvent('web-component-needUserInfoAndToken')
            return;
        }

        self.$triggerEvent(PagesPageElement.tag + '-pageevent', { data })
    }

    /**
     * Sends the userinfo and token to the iframe
     */
    onUserData(userData) {
        let self  = this;
        let token = JSON.parse(window.atob(userData.accessToken.split('.')[1]));

        if (!self.baseUrl) {
            self._ah = token.iss.indexOf('powel.net') !== -1;
            self.baseUrl     = self._ag(token.iss);

            if (!self.tenant) {
                let clientIdSplit = token.client_id.split('_');

                self.tenant = clientIdSplit[clientIdSplit.length - 1];
            }

            self.requestRender('baseurlretrieved');
        }

        self._ae.value?.contentWindow.postMessage({
            event: '$pages.userinfoandtoken',
            data : userData
        }, self.baseUrl);
    }

    /**
     *
     * @param {string} tokenIssuerUrl
     */
    _ag(tokenIssuerUrl) {
        let environment = this.getAttribute('environment');

        if (environment === 'local') {
            return 'https://water.local.voluead.volue.com'
        }

        return 'https://' + (tokenIssuerUrl.indexOf('onpowel') > 0 || origin.indexOf('powel.net') > 0
                                ? 'pages.onpowel.com'
                                : tokenIssuerUrl.indexOf('qaidsrv') > 0
                                    ? 'powelappqawater.azurewebsites.net'
                                    : 'powelappciwater.azurewebsites.net')
    }

    /** Called when destroy has been called on the element, so we do some cleanup */
    onDestroy () {
        super.onDestroy();
        let self = this;

        self._ae = null;
        self._ad   = null;
    }
}

// Define the new web component
if (!window.customElements.get(tag)) {
    window.customElements.define(tag, PagesPageElement);
}